/**
 * 企业 接口
 *
 *  author： 刘书伟
 *  date： 2022-11-19 09:34:48
 */

import request from '@/plugins/request';

/**
 * 企业列表
 * @param query
 */
export function listEnterprise (query) {
    return request({
        url: '/economy/enterprise/list',
        method: 'get',
        params: query
    })
}

/**
 * 企业分页
 * @param query
 */
export function pageEnterprise (query) {
    return request({
        url: '/economy/enterprise/page',
        method: 'get',
        params: query
    })
}

/**
 * 根据id删除企业
 * @param id
 */
export function delEnterprise (id) {
    return request({
        url: '/economy/enterprise/' + id,
        method: 'delete'
    })
}
/**
 * 添加企业
 * @param obj
 */
export function addEnterprise(obj) {
    return request({
        url: '/economy/enterprise',
        method: 'post',
        data: obj
    })
}

/**
 * 修改企业
 * @param obj
 */
export function updateEnterprise (obj) {
    return request({
        url: '/economy/enterprise',
        method: 'put',
        data: obj
    })
}

/**
 * 根据id查询企业
 * @param id
 */
export function getEnterprise (id) {
    return request({
        url: '/economy/enterprise/get-by-id/' + id,
        method: 'get'
    })
}

/**
 * 查询上传进度
 * @param number
 */
export function getExcelImport (number) {
    return request({
        url: '/economy/enterprise/excel/import/' + number,
        method: 'get'
    })
}


/**
 * 企业开户
 * @param number
 */
export function openEnterpriseAccount (id) {
    return request({
        url: '/economy/enterprise/open-enterprise-account/' + id,
        method: 'get'
    })
}


/**
 * 获取账户余额
 * @param number
 */
export function accountBalance () {
    return request({
        url: '/economy/enterprise/account-balance',
        method: 'get'
    })
}



/**
 * 百望用户注册
 * @param number
 */
export function fullElectricInvoiceRegister (id) {
    return request({
        url: '/economy/enterprise/invoice-register/' + id,
        method: 'get'
    })
}

/**
 * 百望用户修改
 * @param number
 */
export function editElectricInvoice (id) {
    return request({
        url: '/economy/enterprise/edit-open-enterprise-account/' + id,
        method: 'get'
    })
}



/**
 * 百望用户注册
 * @param number
 */
export function fullElectricInvoiceUser (id) {
    return request({
        url: '/economy/enterprise/invoice-user/' + id,
        method: 'get'
    })
}


/**
 * 百望用户登录
 * @param number
 */
export function fullElectricInvoiceLogin () {
    return request({
        url: '/economy/enterprise/invoice-login',
        method: 'get'
    })
}



/**
 * 百望用户登录
 * @param number
 */
export function queryFaceRecognitionCode () {
    return request({
        url: '/economy/enterprise/face-recognition-code',
        method: 'get'
    })
}


/**
 * 百望用户注册
 * @param number
 */
export function fullElectricInvoiceFaceRecognitionResult () {
    return request({
        url: '/economy/enterprise/face-recognition-result',
        method: 'get'
    })
}


/**
 * 百望用户登录
 * @param number
 */
export function queryAsynResult (taskID,interfaceType) {
    return request({
        url: '/economy/enterprise/query-asyn-result/'+taskID+'/'+interfaceType,
        method: 'get'
    })
}
